module.exports = __webpack_public_path__ + "be16b4474a5afd85891e05f87d407088.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-22.jpg
// module id = 1163
// module chunks = 0